/* Glow-up before/after slider. Markup + copy are server-rendered
   (sections/kkumi-glow-up.liquid); this handles drag / keyboard / intro peek
   and the flavour switch (images, skin vars, label, CTA). */
(function () {
  function init(root) {
    if (root.dataset.kkBound) return;
    root.dataset.kkBound = '1';

    var rv = root.querySelector('[data-gu-rv]');
    var grip = root.querySelector('[data-gu-grip]');
    var chips = [].slice.call(root.querySelectorAll('[data-gu-chip]'));
    var cta = root.querySelector('[data-gu-cta]');
    var nameEl = root.querySelector('[data-gu-name]');
    var afterKids = [].slice.call(root.querySelectorAll('.rv__layer--after > *'));
    var beforeKids = [].slice.call(root.querySelectorAll('.rv__layer--before > *'));
    if (!rv || !grip || !chips.length) return;
    var skel = root.querySelector('[data-gu-skel]');
    var ctaTpl = root.dataset.ctaLabel || '';
    var token = 0;
    var pos = 50;
    var STORE = 'kk-glow-flavour';

    function set(p) {
      pos = Math.max(0, Math.min(100, p));
      rv.style.setProperty('--pos', pos + '%');
      root.style.setProperty('--p', pos / 100);
      grip.setAttribute('aria-valuenow', Math.round(pos));
    }

    function isImg(el) { return el && el.tagName === 'IMG'; }
    function ready(im) { return im.complete && im.naturalWidth > 0; }
    function loaded(im) {
      return new Promise(function (res) {
        im.addEventListener('load', res, { once: true });
        im.addEventListener('error', res, { once: true });
        if (ready(im)) res();
      });
    }
    function paint(i) {
      [afterKids, beforeKids].forEach(function (kids) {
        kids.forEach(function (k, x) { k.classList.toggle('is-on', x === i); });
      });
    }
    /* Swap the image pair only once both photos have pixels. Until then the
       previous pair stays put under a shimmer overlay, so a slow network shows
       a loading state instead of a blank frame. */
    function showImages(i) {
      var mine = ++token;
      var need = [afterKids[i], beforeKids[i]].filter(isImg).filter(function (im) { return !ready(im); });
      if (!need.length) { paint(i); if (skel) skel.hidden = true; return; }
      if (skel) skel.hidden = false;
      need.forEach(function (im) { im.loading = 'eager'; });
      Promise.race([
        Promise.all(need.map(loaded)),
        new Promise(function (res) { setTimeout(res, 10000); })
      ]).then(function () {
        if (mine !== token) return;
        paint(i);
        if (skel) skel.hidden = true;
      });
    }
    /* Warm every other flavour's photos once the first pair is in, so chip
       switches are instant. */
    function preloadAll() {
      var all = afterKids.concat(beforeKids).filter(isImg);
      all.forEach(function (im) { im.loading = 'eager'; });
    }

    function flav(i, remember) {
      var c = chips[i];
      if (!c) return;
      root.style.setProperty('--a', c.dataset.a);
      root.style.setProperty('--b', c.dataset.b);
      root.style.setProperty('--c', c.dataset.c);
      root.style.setProperty('--wash', c.dataset.wash);
      showImages(i);
      chips.forEach(function (x, n) { x.setAttribute('aria-pressed', n === i ? 'true' : 'false'); });
      var name = (c.dataset.name || '').toLowerCase();
      if (nameEl) {
        nameEl.textContent = name;
        [['n1', '--n1'], ['n2', '--n2'], ['nspace', '--n-space'], ['nfrom', '--n-from'], ['nto', '--n-to']].forEach(function (m) {
          if (c.dataset[m[0]]) nameEl.style.setProperty(m[1], c.dataset[m[0]]);
          else nameEl.style.removeProperty(m[1]);
        });
        /* size the kit name to its longest word so a word never splits */
        nameEl.style.setProperty('--kit-len', String(Math.max.apply(null, name.split(/\s+/).map(function (w) { return w.length; }))));
      }
      if (cta) {
        cta.textContent = ctaTpl.replace('[flavour]', name).toLowerCase();
        if (c.dataset.url) cta.setAttribute('href', c.dataset.url);
      }
      if (remember) { try { localStorage.setItem(STORE, String(i)); } catch (e) {} }
    }

    chips.forEach(function (c, i) { c.addEventListener('click', function () { flav(i, true); }); });

    var drag = false, tap = null;
    function touch() { root.classList.add('is-touched'); }
    function at(x) {
      var r = rv.getBoundingClientRect();
      set((x - r.left) / r.width * 100);
    }
    function begin(x) { drag = true; rv.classList.add('is-drag'); touch(); at(x); }
    /* Mouse / pen grab at once. A finger waits for a sideways move (or a tap)
       so a page scroll that starts on the photo neither jumps the divider nor
       counts as the first swipe (the browser cancels the pointer once it
       scrolls, thanks to touch-action: pan-y). */
    rv.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') tap = { x: e.clientX, y: e.clientY };
      else begin(e.clientX);
      try { rv.setPointerCapture(e.pointerId); } catch (err) {}
    });
    rv.addEventListener('pointermove', function (e) {
      if (tap) {
        var dx = Math.abs(e.clientX - tap.x);
        if (dx < 6 || dx < Math.abs(e.clientY - tap.y)) return;
        tap = null; begin(e.clientX);
      } else if (drag) at(e.clientX);
    });
    function end() { drag = false; tap = null; rv.classList.remove('is-drag'); }
    rv.addEventListener('pointerup', function (e) { if (tap) begin(e.clientX); end(); });
    rv.addEventListener('pointercancel', end);
    grip.addEventListener('keydown', function (e) {
      var s = e.shiftKey ? 10 : 4;
      var to = e.key === 'ArrowLeft' ? pos - s : e.key === 'ArrowRight' ? pos + s
        : e.key === 'Home' ? 0 : e.key === 'End' ? 100 : null;
      if (to === null) return;
      e.preventDefault(); touch(); set(to);
    });

    var saved = 0;
    try { saved = parseInt(localStorage.getItem(STORE), 10) || 0; } catch (e) {}
    flav(saved < chips.length ? saved : 0, false);
    set(78);
    var firstPair = [afterKids[saved < chips.length ? saved : 0], beforeKids[saved < chips.length ? saved : 0]].filter(isImg);
    Promise.race([
      Promise.all(firstPair.map(loaded)),
      new Promise(function (res) { setTimeout(res, 4000); })
    ]).then(preloadAll);

    /* intro peek 78 -> 30 -> 50, once, when 40% in view; cancelled by touch */
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { set(50); return; }
    if (!('IntersectionObserver' in window)) { set(50); return; }
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      io.disconnect();
      var t0 = performance.now(), seq = [[0, 78], [700, 30], [1300, 50]];
      (function step(t) {
        if (root.classList.contains('is-touched')) return;
        var d = t - t0, i = 0;
        while (i < seq.length - 1 && d > seq[i + 1][0]) i++;
        if (i >= seq.length - 1) { set(seq[i][1]); return; }
        var u = Math.min(1, (d - seq[i][0]) / (seq[i + 1][0] - seq[i][0]));
        var e = u < .5 ? 2 * u * u : 1 - Math.pow(-2 * u + 2, 2) / 2;
        set(seq[i][1] + (seq[i + 1][1] - seq[i][1]) * e);
        requestAnimationFrame(step);
      })(t0);
    }, { threshold: .4 });
    io.observe(rv);
  }

  function boot(scope) {
    [].slice.call((scope || document).querySelectorAll('[data-kk-glow-up]')).forEach(init);
  }
  boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
